export const getRange = (start: number, last: number, arr: number[] = []): number[] => {
    if (start === last) {
        return arr;
    }

    return getRange(start + 1, last, [...arr, start]);
};
